var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewLog1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "2.2em",
      height: "2.2em",
      verticalAlign: "middle",
      verflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M896 320 576 320 576 64 640 64 640 256 896 256Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M790.992461 754.013594l186.402874 186.402874-40.72896 40.72896-186.402874-186.402874 40.72896-40.72896Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M686.592 844.8c-83.2 0-153.6-70.4-153.6-153.6s70.4-153.6 153.6-153.6 153.6 70.4 153.6 153.6C833.792 774.4 769.792 844.8 686.592 844.8zM686.592 601.6c-51.2 0-89.6 38.4-89.6 89.6s38.4 89.6 89.6 89.6 89.6-38.4 89.6-89.6S731.392 601.6 686.592 601.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M640 1024 187.392 1024C110.592 1024 64 953.6 64 870.4L64 129.216C64 54.656 110.592 0 187.392 0l441.6 0L960 249.6 960 640l-64 0L896 275.2 609.792 64l-422.4 0C142.592 64 128 97.728 128 133.44L128 876.8C128 921.6 142.592 960 187.392 960L640 960 640 1024z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192 192l256 0 0 64-256 0 0-64Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192 320l320 0 0 64-320 0 0-64Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M192 448l384 0 0 64-384 0 0-64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewLog1);
export default __webpack_public_path__ + "static/media/view-log-1.fdd0966e.svg";
export { ForwardRef as ReactComponent };